import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const actualidad = {
	state: {
		noticias : ''
	},
	getters: {
		categoriaNoticias : (state) => {

			let noticias = state.noticias;

			if(!!noticias){

				let categorias = new Array();

				noticias.forEach( noticia => {
					if(!categorias.some(c => c.slug == noticia.categoria.slug )){
						categorias.push(noticia.categoria)
					}
				});

				return categorias;
			}
		},
		getNoticiasFiltradas : state => {

			return (filtro) => {

				let searchIn = ['titulo', 'entradilla']

				let noticias = state.noticias;

				let filtradas;

				if(!!noticias){

					filtradas = noticias.filter(noticia => {

						let can = false;

						searchIn.forEach(where => {
							(noticia[where].toLowerCase().includes(filtro.search.toLowerCase())) ? can = true : '';
						});

						return (can) ? noticia : '';
					});

					filtradas = filtradas.filter(noticia => noticia.categoria.slug.includes(filtro.categoria));
				}

				return filtradas;

			}
		},
		getNoticias : state => {
			return state.noticias
		}
	},
	actions: {
		requestNoticias : ({commit},) => {
			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/noticias`)
				.then(response => {
					commit('setNoticias', response.data.entries);
					resolve(true);
				})
				.catch(error => reject(error));

			});
		},
		requestNoticia : ({commit}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/noticia/${slug}`)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => reject(error));

			});
		}
	},
	mutations: {
		setNoticias : (state, noticias) => {
			state.noticias = noticias;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/noticias.js